<div class="draggable-item group">
  @if (isInsideContainer() && isEditable()) {
    <div class="drag-handle" contenteditable="false" draggable="true" data-drag-handle>
      <dojo-icon icon="grip-dots-vertical" [size]="12" />
    </div>
  }
  <div class="content" tiptapNodeViewContent></div>
</div>
